import {ProgressItem} from "../../components/items/progress-item/progress-item"
import {cartApi, cartData} from "../cart-api/cart-api"
import {rerenderCartDropdown} from "./cart-dropdown--rerender";

export const initCartAll = () => {
  const dropdowns = document.querySelectorAll(".i-cart-overview")
  const progress = new ProgressItem(document.querySelector(".i-progress"))

  dropdowns.forEach((dropdown) => {
    const clearButton = document.querySelector(".--js-cart-clear")

    clearButton?.addEventListener("click", async (event: Event) => {
      event.preventDefault()

      dropdown?.classList.add("--loading")

      const response = await cartApi.deleteAll()

      if (!response.ok) {
        dropdown?.classList.remove("--loading")
        return
      }

      const data = (await response.json()) as cartData

      console.log(data)

      if (!data.success) {
        dropdown?.classList.remove("--loading")
        return
      }

      if (data.progress.remaining && data.progress.percentage) {
        progress.setProgress(data.progress.remaining, Number(data.progress.percentage))
      }

      rerenderCartDropdown(data.headerDropdown, data.totalPrice.main, data.amount)

      document.querySelectorAll(".i-cart").forEach((item) => {
        item.remove()
      })

      dropdown.classList.add("--open")
      dropdown?.classList.remove("--loading")
    })
  })
}

initCartAll()
